module.exports = __webpack_public_path__ + "static/img/logo@2x_back.a2b644a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo@2x_back.png
// module id = EuwF
// module chunks = 70